export const getContentByName = (arr: Array<any>, key: string) => {
  let value = undefined;
  arr.forEach((el) => {
    if (el.name === key) {
      value = el.content;
    }
  });
  return value;
};
